<div class="row">
  @for (checkboxControl of this.formName.value; track checkboxControl) {
    <div class="col-6 col-md-4 mt-1">
      <label class="container" for="{{ checkboxControl.name }}" [attr.data-cy]="checkboxControl.name + '-filtration-checkbox'">
        <input id="{{ checkboxControl.name }}" type="checkbox" [(ngModel)]="checkboxControl.value" checked (change)="inputUpdated()">
        <span class="checkmark"></span>
        @if (translatePrefix) {
          {{ translatePrefix + checkboxControl.name | translate }}
        } @else if (checkboxControl.translate) {
            {{ checkboxControl.name | translate }}
        } @else {
          {{ checkboxControl.name }}
        }
      </label>
    </div>
  }
</div>